import React, { useState, useEffect, useContext } from 'react'
import { PageContainerMain, Box, BottomAppCallout } from '../../../Components/Layout'
import { QuestionContext } from '../../../Context'
import { AuthContext } from '../../../Api/firebase'
import { Question } from '../../../Api'
import { QuestionElem } from '../../../Components/Questions/Question'
import { useGroupQuestionUrlParams } from '../../../Context/utils'
import { QuestionSection } from '../styles'
import { TopRow } from './components/TopRow'
import { ProgressBarCon } from './components/ProgressBarCon'
import { SummaryStyle } from './Summary/styles'
import { Summary } from './Summary/Summary'
import { AdUnit } from '../../../Components/Ads/AdUnit'
import { HelmetProvider } from 'react-helmet-async'
import { SEOTags } from '../../../Components/SEO/SEOTags'

const GroupQuestions: React.FC = () => {
  const qId = useGroupQuestionUrlParams()
  const {
    getQuestionSet,
    questionIndex,
    questions: qItems,
  } = useContext(QuestionContext)!
  const { uid } = useContext(AuthContext)!
  const [questions, setQuestions] = useState<Question[]>([])

  useEffect(() => {
    if (!qId?.groupId || !uid) return
    getQuestions(qId.groupId)
  }, [uid])

  useEffect(() => {
    setQuestions(questions)
  }, [qItems, questionIndex])

  const getQuestions = async (groupId: string) => {
    let params = {
      group: groupId,
      qType: 'group',
    }
    let q = await getQuestionSet(params)
    if (q.length > 0) {
      setQuestions(q) // all questions are returned in array
    }
  }

  return (
    <HelmetProvider>
      <SEOTags
        title="Group Questions"
        description="Answer trivia, polls, and vote on PLL topics."
        keywords="voting, polls"
      />
      <PageContainerMain>
        <AdUnit bannerType="bannerMain" aria-label="Group questions page ad" />
        <Box noMargin>
          <QuestionSection>
            {questions.length > 0 && questions[0]?.groupText && (
              <TopRow question={questions[0]} />
            )}
            <ProgressBarCon />
            {questions.length > 0 && questionIndex <= questions.length - 1 && (
              <div className="qCon">
                <QuestionElem question={questions[questionIndex]} />
              </div>
            )}
            {questions.length > 0 && questionIndex > questions.length - 1 && (
              <SummaryStyle>
                <Summary />
              </SummaryStyle>
            )}
          </QuestionSection>
        </Box>
        <AdUnit bannerType="bannerSecond" aria-label="Group questions page ad second" />
        {questions.length > 0 && (
          <BottomAppCallout
            appLink={questions[0].shareLink}
            location="Group_Questions_Page"
            text="This experience is better in the PLL App!"
          />
        )}
      </PageContainerMain>
    </HelmetProvider>
  )
}

export default GroupQuestions
